export default __webpack_public_path__ + "images/wave.72541c828ec878f4a5e94a93e75a00e2.svg";